// extracted by mini-css-extract-plugin
module.exports = {"oauthBtn":"cfea"};